import styled from "styled-components"

export const Container = styled.div`
display: grid;


  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    grid-template-columns: 1.5fr 1fr;
  }
`

export const Columns = styled.div`
  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    display: grid;
    gap: 3rem;
  }

  ${`@media (min-width: ${1200 + 1}px)`} {
    grid-template-columns: 1fr 1fr;
  }
`

export const Email = styled.div`
  cursor: pointer;
  position: relative;

  &:after {
    content: "";
    width: 0;
  }

  &:hover {
    &:after {
      transition: 0.4s width ease-out;
      content: "";
      width: 100%;
      background: ${p => p.theme.colors.greyDark};
      height: 0.1rem;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`
